<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h2 class="portal-titulo">
    Seja bem-vindo ao 
    <span [ngClass]="getTitleClass()">{{ getPortalTitle() }}</span>
  </h2>

  <ng-container *ngIf="tituloSubcard; else listaPrincipal">
    <div fxLayout="row wrap" fxLayoutGap="24px" fxLayoutAlign="center start">
      <mat-card
        *ngFor="let f of subcards"
        class="card"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="abrirPDF(f.file)"
      >
        <span class="material-symbols-rounded icon" [ngClass]="getTitleClass()">calendar_month</span>
        <h4>{{ f.ano }}</h4>
      </mat-card>
    </div>
  </ng-container>

  <ng-template #listaPrincipal>
    <div fxLayout="row wrap" fxLayoutGap="24px" fxLayoutAlign="center start">
      <mat-card
        *ngFor="let card of cards"
        class="card"
        fxLayout="column"
        fxLayoutAlign="center center"
        [style.cursor]="card.file || card.files ? 'pointer' : 'default'"
        (click)="abrirSubcards(card)"
      >
        <span class="material-symbols-rounded icon" [ngClass]="getTitleClass()">
          {{ card.icon }}
        </span>
        <h3>{{ card.label }}</h3>
      </mat-card>
    </div>
  </ng-template>
</div>
